import {createAsyncThunk} from "@reduxjs/toolkit";
import {UserCRUDRecord} from "@commons/mapping/UserCRUDRecord";
import Axios from "axios";
import {config} from "@commons/config.instance";
import {CambioPasswordResult} from "@commons/actions/authentication.action";
import {TokenRecord} from "@commons/mapping/TokenRecord";
import {updateUserSuccess} from "@commons/core.slice";

//**********************************************
//****** INVIO EMAIL ATTIVAZIONE - INIZIO *****
/**
 * PATCH https://fpnet2.ericed.it/FPNet2021/access/my-account/send-email/3054?auth_token=f313676472a98cdc59ee2ed21481109b&nowId=1690471199327
 * @param user
 */
function inviaEmailAttivazioneApi(user: UserCRUDRecord): Promise<UserCRUDRecord> {
    const payload = JSON.parse(JSON.stringify(user)); // hot fix per rimuovere <alert4PswExpiry>, todo da rivedere!!!
    payload.alert4PswExpiry = undefined;
    return Axios.patch<UserCRUDRecord>(config.getBaseUrl('HR') + `/access/my-account/send-email/${user.idUser}`, payload)
        .then(res => {
            return res.data;
        })
}

export const inviaEmailAttivazione = createAsyncThunk<UserCRUDRecord, UserCRUDRecord>(
    'invia-email-attivazione',
    async (payload, {dispatch, rejectWithValue}) => {
        try {
            const user = await inviaEmailAttivazioneApi(payload);
            //dispatch(changeTokenSuccess(tokenResult));
            return user;
        } catch (err) {
            return rejectWithValue('errore!')
        }
    }
)
//****** INVIO EMAIL ATTIVAZIONE - FINE *****

//*********************************
//****** UPDATE USER - INIZIO *****

export type UpdateUserResult = Pick<UserCRUDRecord, 'URI' | 'emailVerificata' | 'lastUpdateTrace'> & { tokenVerificaEmail: TokenRecord }

/**
 * https://fpnet2.ericed.it/FPNet2021/access/my-account/3054?auth_token=f313676472a98cdc59ee2ed21481109b&nowId=1690471018357
 * @param user
 */
function updateUserApi(user: Partial<UserCRUDRecord>): Promise<UpdateUserResult> {
    const payload = JSON.parse(JSON.stringify(user)); // hot fix per rimuovere <alert4PswExpiry>, todo da rivedere!!!
    payload.alert4PswExpiry = undefined;
    return Axios.put<UpdateUserResult>(config.getBaseUrl('HR') + `/access/my-account/${user.idUser}`, payload)
        .then(res => {
            return res.data;
        })
}

export const updateUser = createAsyncThunk<UpdateUserResult, Partial<UserCRUDRecord>>(
    'update/profile',
    async (payload, {dispatch, rejectWithValue}) => {
        try {
            const user = await updateUserApi(payload);
            dispatch(updateUserSuccess(payload));
            return user as UpdateUserResult;
        } catch (err) {
            return rejectWithValue('errore!')
        }
    }
)
//****** UPDATE USER - FINE *****

//*************************************
//****** CAMBIO PASSWORD - INIZIO *****
interface ChangeUserPasswordPayload {
    currentPassword: string,
    idUser: number,
    password?: string,
    passwordInChiaro: string,
}

function changeUserPasswordApi(payload: ChangeUserPasswordPayload): Promise<CambioPasswordResult> {

    return Axios.patch<CambioPasswordResult>(config.getBaseUrl('HR') + `/access/my-account/${payload.idUser}`, payload)
        .then(res => {
            return res.data;
        })
}

export const cambioPasswordUtente = createAsyncThunk<CambioPasswordResult, ChangeUserPasswordPayload>(
    'update/password',
    async (payload, {dispatch, rejectWithValue}) => {
        try {
            const result = await changeUserPasswordApi(payload);
            //dispatch(changeTokenSuccess(tokenResult));
            return result;
        } catch (err) {
            return rejectWithValue('errore!')
        }
    }
)
//****** CAMBIO PASSWORD - FINE *****

//************************************
//****** ATTIVO ACCOUNT - INIZIO *****
/**
 * PATCH https://fpnet2.ericed.it/FPNet2021/access/my-account/send-email/3054?auth_token=f313676472a98cdc59ee2ed21481109b&nowId=1690471199327
 * @param user
 */
function attivaAccountApi(token: string): Promise<boolean> {
    return Axios.patch<void>(config.getBaseUrl('FPNet') + `/access/my-account/validate-email/${token}`, {})
        .then(() => true, () => false)
}

export const attivaAccount = createAsyncThunk<boolean, string>(
    'attiva-account',
    async (payload, {dispatch, rejectWithValue}) => {
        try {
            const resutl = await attivaAccountApi(payload);
            if (!resutl) throw false;
            return resutl;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
)
//****** ATTIVO ACCOUNT - FINE *****

